import {useParams} from 'react-router-dom'
import {PerfilCargoChrome} from '@/components/perfil-cargo-chrome'
import {PerfilCondiciones} from '@/components/perfil-condiciones'
import {useOperatorPage} from '@/components/no-access-state'
import {useCapabilities} from '@/hooks/empresa/organizacion/use-businesses'
import {useGodModeReadOnly} from '@/hooks/platform/use-god-mode'
import {usePerfilCargo} from '@/hooks/empresa/perfil_cargo/use-perfiles-cargo'

/** Pestaña propia porque las condiciones tienen su propia firma: embebidas competían con «Confirmar el perfil». */
export function PerfilCargoCondicionesPage() {
  const {businessId, positionId} = useParams()
  const {business, guard} = useOperatorPage(businessId)
  const capabilities = useCapabilities(businessId)
  const godReadOnly = useGodModeReadOnly()
  const perfil = usePerfilCargo(businessId, positionId)
  if (guard) return guard
  return (
    <PerfilCargoChrome
      businessId={businessId!}
      positionId={positionId!}
      cargo={perfil.data?.cargo}
      testId="perfil-cargo-condiciones-page">
      {business && (
        <PerfilCondiciones
          businessId={businessId!}
          positionId={positionId!}
          puedeFirmar={capabilities.sgsst_firmar && !godReadOnly}
          bloqueoFirma={capabilities.firmar_bloqueado_por ?? null}
        />
      )}
    </PerfilCargoChrome>
  )
}
